import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { SR_CHAT_ACCENT, SR_CHAT_ACCENT_HOVER } from "../sr-constants";
import { SrVoiceMicButton } from "./sr-voice-mic-button";

type Props = {
    canSend: boolean;
    disabled?: boolean;
    isRecording: boolean;
    voiceOn: boolean;
    onSend: () => void;
    onToggleVoice: () => void;
};

export const SrChatComposerActions: React.FC<Props> = ({
    canSend,
    disabled,
    isRecording,
    voiceOn,
    onSend,
    onToggleVoice,
}) => (
    <div className="flex items-center justify-between gap-2 border-t border-slate-100 px-2.5 py-2">
        <p className="sr-chat-hint hidden px-1.5 text-slate-400 sm:block">
            Enter to send · Shift+Enter for new line
        </p>
        <div className="ml-auto flex items-center gap-1">
            {voiceOn && (
                <SrVoiceMicButton
                    isRecording={isRecording}
                    disabled={disabled}
                    onClick={onToggleVoice}
                />
            )}
            <Tooltip title="Send">
                <span>
                    <IconButton
                        onClick={onSend}
                        disabled={!canSend}
                        aria-label="send"
                        sx={{
                            backgroundColor: canSend ? SR_CHAT_ACCENT : "#E2E8F0",
                            color: canSend ? "#fff" : "#94A3B8",
                            width: 34,
                            height: 34,
                            borderRadius: "10px",
                            "&:hover": {
                                backgroundColor: canSend
                                    ? SR_CHAT_ACCENT_HOVER
                                    : "#E2E8F0",
                            },
                            "&.Mui-disabled": {
                                backgroundColor: "#E2E8F0",
                                color: "#94A3B8",
                            },
                        }}
                    >
                        <SendRoundedIcon sx={{ fontSize: 17 }} />
                    </IconButton>
                </span>
            </Tooltip>
        </div>
    </div>
);
